export default __webpack_public_path__ + "static/pesdk-41004662254c057249ab6e194df5edf8.png";